<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2p"><a id="page_25">SACAGAWEA</a></h2><a id="page_25">
</a><h2 class="h2p-sub"><a id="page_25">2261</a><a id="page_26"></a></h2><a id="page_26">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part03.vue?388cdd34